import {URL} from '@/API/urls';

enum Routes {
  notifications,
}
const GET_SOCKET = (route: keyof typeof Routes) => {
  return `${URL.BASE_ADMIN}/${route}`;
};
export default GET_SOCKET;
